import { useEffect, useRef, useState } from "react";
import NewWindow from "react-new-window";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { Icon } from "@iconify/react";
import Download from "@mui/icons-material/Download";
import { Autocomplete, Button, IconButton, TextField } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import "./QualityAssurance.css";
import ActionColumnQA from "./ActionColumnQA";
import QAForm from "./QAForm";
import AssignmentDetails from "../Campaign/AssignmentDetails";
import Loader from "../Components/Loader";
import useWindowDimensions from "../Hooks/useWindowDimensions";
import { getRecordingFiles } from "../Store/Actions/CallAction";

import {
  filteredApplicationStatus,
  filteredCampaign,
  getListAgent,
  getListSPV,
  QAViewTable,
} from "../Store/Actions/QAAction";

import { getAllMaster, getInboundLog } from "../Store/Actions/TicketAction";
import { SET_TABLE_PAGE } from "../Store/Types/TicketTypes";
import { getACDDevice } from "../Store/Actions/MonitoringAction";
import formatSecondsToDuration from "../Helper/formatSecondsToDuration";

export default function QualityAssurance({
  isInbound,
  isTelemarketing,
  GenerateNonPopUpFiles,
}) {
  const [masterData, setMasterData] = useState({}); // Master data for search select options
  const [agentData, setAgentData] = useState([]);
  const [campaignData, setCampaignData] = useState([]);
  const [countData, setCountData] = useState(0);
  const [SPVData, setSPVData] = useState([]);
  const [statusData, setStatusData] = useState([]);

  const initialParams = {
    ACDDevice: "",
    agent: "",
    campaign: "",
    contactName: "",
    durationCall: "",
    phoneNo: "",
    skip: 0,
    SPV: "",
    status: "",

    // Range initialized as 30 days before current date
    startDate: moment().subtract(1, "months"),
    endDate: moment(),

    // Range initialized as 30 days before current date
    startSellingTime: moment().subtract(1, "months"),
    endSellingTime: moment(),
  };

  const [searchParams, setSearchParams] = useState(initialParams);

  const initialDisplayValues = {
    ACDDevice: [],
    agent: [],
    campaign: [],
    durationCall: [],
    SPV: [],
    status: [],
  };

  // Display values for autocomplete components
  const [displayValues, setDisplayValues] = useState(initialDisplayValues);

  const [isSearchLoading, setIsSearchLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isQAFormDialogShown, setIsQAFormDialogShown] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState(null);
  const [isRecordingLoading, setIsRecordingLoading] = useState(false);
  const [isRecordingPlaying, setIsRecordingPlaying] = useState(false);
  const [isSeekVoiceAllowed, setIsSeekVoiceAllowed] = useState(null);
  const [listInbound, setListInbound] = useState([]);
  const [listQA, setListQA] = useState([]);
  const [selectedRecording, setSelectedRecording] = useState(null);
  const [ACDDevices, setACDDevices] = useState([]);
  const [selectedLogItem, setSelectedLogItem] = useState(null);
  const dispatch = useDispatch();
  const recordingRef = useRef();
  const { agentPermission, myInfo } = useSelector((state) => state.auth);
  const { tablePage } = useSelector((state) => state.ticket);
  const { width } = useWindowDimensions();

  const dummy = [
    {
      ID: 1,
      InteractionTime: "2022-08-29T16:26:18.510Z",
      CustomerName: "Marco",
      ContactRef: 52,
      CampaignName: "COLLECTION",
      DataFilter: "WHATSAPP",
      AgentName: "Administrator",
      Status: "Tidak Diangkat",
      ScoreQA: "MANTAP",
      Duration: 7000,
    },
  ];

  // Run on first load, fetch tickets and get search options data
  useEffect(() => {
    setIsSearchLoading(true);

    // Get master data for search select options
    getAllMaster()
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("master data", response.data);

          setMasterData(response.data);
          setIsSearchLoading(false);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));

    filteredApplicationStatus({ agentid: myInfo.user.AgentTSS.AgentID })
      .then((response) => {
        if (response.status) {
          setStatusData(response.data);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });

    filteredCampaign({ agentid: myInfo.user.AgentTSS.AgentID })
      .then((response) => {
        if (response.status) {
          setCampaignData(response.data);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
      });

    getListAgent()
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("agent data", response.data);

          setAgentData(response.data);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));

    getListSPV()
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("SPV data", response.data);

          setSPVData(response.data);
          setIsSearchLoading(false);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));

    getACDDevice(myInfo.user.ClientID)
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("ACD devices: ", response.data);

          setACDDevices(response.data);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));
  }, []);

  useEffect(() => {
    fetchData();
  }, [isQAFormDialogShown]);

  // Get seek voice permission
  useEffect(() => {
    const seekVoicePermission = agentPermission.find(
      (permission) => permission.PermissionCode === "User.SeekVoice"
    );

    if (seekVoicePermission && seekVoicePermission.PermissionAccess === "A") {
      setIsSeekVoiceAllowed(true);
    } else {
      setIsSeekVoiceAllowed(false);
    }
  }, [agentPermission]);

  // Event listener for audio `ended` event
  useEffect(() => {
    recordingRef.current &&
      recordingRef.current.addEventListener("ended", () =>
        setIsRecordingPlaying(false)
      );

    return () => {
      recordingRef.current &&
        recordingRef.current.removeEventListener("ended", () =>
          setIsRecordingPlaying(false)
        );
    };
  }, [recordingRef.current]);

  const columns = [
    {
      field: "InteractionTime",
      flex: 1.25,
      headerName: "Interaction Time",

      renderCell: (params) =>
        moment.utc(params.row.InteractionTime).format("DD-MMM-yyyy HH:mm:ss"),
    },

    {
      field: "CustomerName",
      flex: 1,
      headerName: "Customer Name",
    },

    {
      field: "ContactRef",
      flex: 1,
      headerName: "Contact Ref",
    },

    {
      field: "CampaignName",
      flex: 1,
      headerName: "Campaign Name",
    },

    {
      field: "DataFilter",
      flex: 1,
      headerName: "Data Filter",
    },

    {
      field: "AgentName",
      flex: 1,
      headerName: "Agent Name",
    },

    {
      field: "Status",
      flex: 1,
      headerName: "Status",
    },

    {
      field: "ScoreQA",
      flex: 1,
      headerName: "Score QA",
    },

    {
      field: "Duration",
      flex: 0.6,
      headerName: "Duration",

      renderCell: (params) =>
        moment.utc(params.row.Duration).format("HH:mm:ss"),
    },

    {
      align: "center",
      flex: 0.8,
      headerAlign: "center",
      headerName: "Action",

      renderCell: () => {
        return (
          <div>
            <IconButton
              onClick={() => {
                if (isTelemarketing) {
                  // Temp hardcoded
                  setSelectedAssignment(163);
                } else {
                  setIsQAFormDialogShown(true);
                }
              }}
            >
              <Icon
                color="#7e7e7e"
                height="26"
                icon="ic:baseline-remove-red-eye"
                width="26"
              />
            </IconButton>

            <audio ref={recordingRef}>
              <source
                src={`data:audio/wav;base64,${selectedRecording?.filebytes}`}
              />
            </audio>

            <IconButton
              onClick={() => {
                if (!selectedRecording) {
                  setIsRecordingLoading(true);

                  // Temp hard coded
                  getRecordingFiles(
                    String.raw`2023\11\02\dpi_1698923402.48.gsm`
                  )
                    .then((response) => {
                      if (response.status) {
                        setSelectedRecording(response.data);

                        recordingRef.current = new Audio(
                          `data:audio/wav;base64,${response.data.filebytes}`
                        );

                        setIsRecordingLoading(false);
                      } else {
                        console.log("error", response.error);
                        toast.error(response.error);
                        setIsRecordingLoading(false);
                      }
                    })
                    .catch((err) => {
                      console.log("err", err);
                      toast.error(err);
                      setIsRecordingLoading(false);
                    });
                } else if (isRecordingLoading) {
                  return;
                }
              }}
            >
              <Icon
                color="#7e7e7e"
                height="26"
                icon={isRecordingLoading ? "eos-icons:loading" : "ion:play"}
                width="26"
              />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const columnsInbound = [
    {
      field: "calltime",
      flex: 1.25,
      headerName: "Call Time",

      renderCell: (params) =>
        moment.utc(params.row.calltime).format("DD-MMM-yyyy HH:mm:ss"),
    },

    {
      field: "contactname",
      flex: 1,
      headerName: "Customer Name",
    },

    {
      field: "callerno",
      flex: 1,
      headerName: "Caller No",
    },

    {
      field: "acdname",
      flex: 1,
      headerName: "ACD Name",
    },

    {
      field: "agentname",
      flex: 1,
      headerName: "Agent Name",
    },

    {
      field: "qaname",
      flex: 1,
      headerName: "QA Name",
    },

    {
      field: "totalscore",
      flex: 1,
      headerName: "Total Score",
    },

    {
      field: "scoringtime",
      flex: 1,
      headerName: "Scoring Time",

      renderCell: (params) =>
        params.row.scoringtime
          ? moment.utc(params.row.scoringtime).format("DD-MMM-yyyy HH:mm:ss")
          : "",
    },

    {
      field: "talkduration",
      flex: 0.6,
      headerName: "Duration",
      renderCell: (params) => formatSecondsToDuration(params.row.talkduration),
    },

    {
      align: "center",
      flex: 0.8,
      headerAlign: "center",
      headerName: "Action",

      renderCell: (params) => (
        <ActionColumnQA
          params={params}
          setIsQAFormDialogShown={setIsQAFormDialogShown}
          setSelectedLogItem={setSelectedLogItem}
        />
      ),
    },
  ];

  const columnsTSS = [
    {
      field: "ContactFirstName",
      flex: 1,
      headerName: "Customer Name",
    },

    {
      field: "CampaignName",
      flex: 1,
      headerName: "Campaign Name",
    },

    {
      field: "AgentCode",
      flex: 1,
      headerName: "Agent Name",
    },

    {
      field: "SPVCode",
      flex: 1,
      headerName: "SPV",
    },

    {
      field: "QACode",
      flex: 1,
      headerName: "QA",
    },

    {
      field: "SellingTime",
      flex: 1.25,
      headerName: "Selling Time",

      renderCell: (params) =>
        moment(params.row.SellingTime).format("DD/MM/yyyy HH:mm:ss"),
    },

    {
      field: "Status",
      flex: 1,
      headerName: "Status",
    },

    {
      field: "NOS",
      flex: 1,
      headerName: "NOS",
    },

    {
      field: "ActionDurationFormatted",
      flex: 0.6,
      headerName: "Duration",
    },

    {
      field: "Comment",
      flex: 1,
      headerName: "Comment",
    },

    {
      align: "center",
      flex: 0.8,
      headerAlign: "center",
      headerName: "Action",

      renderCell: (params) => {
        return (
          <div>
            <IconButton
              onClick={() => {
                if (isTelemarketing) {
                  setSelectedAssignment(params.row.TSSAssignmentID);
                } else {
                  setIsQAFormDialogShown(true);
                }
              }}
            >
              <Icon
                color="#7e7e7e"
                height="26"
                icon="ic:baseline-remove-red-eye"
                width="26"
              />
            </IconButton>
          </div>
        );
      },
    },
  ];

  function fetchData(skip = 0) {
    setIsLoading(true);

    if (isInbound) {
      getInboundLog(
        moment(searchParams.startDate).format("yyyy-MM-DD"),
        moment(searchParams.endDate).format("yyyy-MM-DD"),
        searchParams.ACDDevice,
        searchParams.agent,
        searchParams.contactName,
        searchParams.phoneNo,
        skip,
        50
      )
        .then((response) => {
          if (response.status) {
            setIsLoading(false);
            setListInbound(response.data.data ?? []);
            setCountData(response.data.countdata ?? 0);
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => console.log("err", err));
    } else {
      QAViewTable({
        agentid: myInfo.user.AgentTSS.AgentID,
        filter: `ContactFirstName=${searchParams.contactName}|Status=${
          searchParams.status
        }|AgentName=${searchParams.agent}|LeaderName=${
          searchParams.SPV
        }|SubmitTime=${moment(searchParams.startSellingTime).format(
          "yyyy/MM/DD"
        )} - ${moment(searchParams.endSellingTime).format(
          "yyyy/MM/DD"
        )}|Campaign=${searchParams.campaign}|Duration=${
          searchParams.durationCall
        }`,
        page: 1,
      })
        .then((response) => {
          if (response.status) {
            setListQA(response.data.models);
            setIsLoading(false);
          } else {
            console.log("error", response.error);
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.log("err", err);
          setIsLoading(false);
        });
    }
  }

  return (
    <div className="quality-assurance">
      <div className="list_header">
        <div className="list_headerLeft">
          {selectedAssignment && (
            <Icon
              icon="material-symbols:arrow-back-ios-new-rounded"
              width="32"
              height="32"
              onClick={() => setSelectedAssignment(null)}
            />
          )}

          <div className="campaign-name">
            <h1>Quality Assurance</h1>
          </div>
        </div>
      </div>

      <div className="containerQA">
        {selectedAssignment ? (
          <AssignmentDetails
            assignmentID={selectedAssignment}
            setSelectedAssignment={setSelectedAssignment}
            GenerateNonPopUpFiles={GenerateNonPopUpFiles}
            isTelemarketing
          />
        ) : (
          <div className="quality-assurance-contents">
            <div className="container-header">
              {isSearchLoading ? (
                <Loader />
              ) : (
                <div className="search">
                  <div className="row">
                    <div className="qa-type">
                      <Icon
                        className="icon"
                        height="30"
                        icon={
                          isTelemarketing
                            ? "icon-park-outline:sales-report"
                            : "ri:flag-line"
                        }
                      />
                    </div>

                    {isTelemarketing ? (
                      <>
                        <TextField
                          className="search-item"
                          label="Contact Name"
                          value={searchParams.contactName}
                          onChange={(event) =>
                            setSearchParams({
                              ...searchParams,
                              contactName: event.target.value,
                            })
                          }
                        />

                        <Autocomplete
                          className="search-item"
                          filterSelectedOptions
                          multiple
                          options={statusData}
                          value={displayValues.status}
                          getOptionLabel={(status) => status.status}
                          onChange={(event, value) => {
                            setSearchParams({
                              ...searchParams,
                              status: value?.length
                                ? value.map((val) => val.status)
                                : "",
                            });

                            setDisplayValues({
                              ...displayValues,
                              status: value,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Status" />
                          )}
                        />

                        <Autocomplete
                          className="search-item"
                          filterSelectedOptions
                          multiple
                          options={agentData}
                          value={displayValues.agent}
                          getOptionLabel={(agent) => agent.name}
                          onChange={(event, value) => {
                            setSearchParams({
                              ...searchParams,
                              agent: value?.length
                                ? value.map((val) => val.name)
                                : "",
                            });

                            setDisplayValues({
                              ...displayValues,
                              agent: value,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Agent" />
                          )}
                        />
                      </>
                    ) : (
                      <>
                        <div className="date-range">
                          <DatePicker
                            disableFuture
                            label="Start Date"
                            maxDate={searchParams.endDate}
                            value={searchParams.startDate}
                            renderInput={(params) => <TextField {...params} />}
                            onChange={(newValue) =>
                              setSearchParams({
                                ...searchParams,
                                startDate: newValue,
                              })
                            }
                          />

                          <Icon
                            color="#7E7E7E"
                            icon="mdi:arrow-expand"
                            width="24"
                          />

                          <DatePicker
                            disableFuture
                            label="End Date"
                            minDate={searchParams.startDate}
                            value={searchParams.endDate}
                            renderInput={(params) => <TextField {...params} />}
                            onChange={(newValue) =>
                              setSearchParams({
                                ...searchParams,
                                endDate: newValue,
                              })
                            }
                          />
                        </div>

                        <Autocomplete
                          className="search-item"
                          filterSelectedOptions
                          multiple
                          options={isInbound ? ACDDevices : agentData}
                          value={
                            isInbound
                              ? displayValues.ACDDevice
                              : displayValues.agentSearch
                          }
                          getOptionLabel={(data) =>
                            isInbound ? data.acdname : data.AgentName
                          }
                          onChange={(event, value) => {
                            if (isInbound) {
                              setSearchParams({
                                ...searchParams,

                                ACDDevice: value?.length
                                  ? value.map((val) => val.acddeviceid)
                                  : "",
                              });

                              setDisplayValues({
                                ...displayValues,
                                ACDDevice: value,
                              });
                            } else {
                              setSearchParams({
                                ...searchParams,

                                filteragents: value?.length
                                  ? value.map((val) => val.AgentID)
                                  : "",
                              });

                              setDisplayValues({
                                ...displayValues,
                                agentSearch: value,
                              });
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={isInbound ? "ACD Device" : "Campaign"}
                            />
                          )}
                        />
                      </>
                    )}

                    <button
                      className="clear-button"
                      onClick={() => {
                        setSearchParams(initialParams);
                        setDisplayValues(initialDisplayValues);
                      }}
                    >
                      <Icon icon="ri:brush-3-line" width="20" height="20" />
                      Clear
                    </button>
                  </div>

                  <div className="row">
                    {isTelemarketing ? (
                      <>
                        <Autocomplete
                          className="search-item"
                          filterSelectedOptions
                          multiple
                          options={SPVData}
                          value={displayValues.SPV}
                          getOptionLabel={(SPV) => SPV.name}
                          onChange={(event, value) => {
                            setSearchParams({
                              ...searchParams,
                              SPV: value?.length
                                ? value.map((val) => val.name)
                                : "",
                            });

                            setDisplayValues({
                              ...displayValues,
                              SPV: value,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="SPV" />
                          )}
                        />

                        <Autocomplete
                          className="search-item"
                          filterSelectedOptions
                          multiple
                          options={campaignData}
                          value={displayValues.campaign}
                          getOptionLabel={(campaign) => campaign.name}
                          onChange={(event, value) => {
                            setSearchParams({
                              ...searchParams,
                              campaign: value?.length
                                ? value.map((val) => val.name)
                                : "",
                            });

                            setDisplayValues({
                              ...displayValues,
                              campaign: value,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Campaign" />
                          )}
                        />

                        <Autocomplete
                          className="search-item"
                          filterSelectedOptions
                          multiple
                          options={[
                            {
                              text: "0-15 minutes",
                              value: 1,
                            },

                            {
                              text: "15-30 minutes",
                              value: 2,
                            },

                            {
                              text: "30-45 minutes",
                              value: 3,
                            },

                            {
                              text: "45-60 minutes",
                              value: 4,
                            },

                            {
                              text: "> 60 minutes",
                              value: 5,
                            },
                          ]}
                          value={displayValues.durationCall}
                          getOptionLabel={(duration) => duration.text}
                          onChange={(event, value) => {
                            setSearchParams({
                              ...searchParams,
                              durationCall: value?.length
                                ? value.map((val) => val.value)
                                : "",
                            });

                            setDisplayValues({
                              ...displayValues,
                              durationCall: value,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Duration Call" />
                          )}
                        />
                      </>
                    ) : (
                      <>
                        <TextField
                          className="search-item"
                          label="Contact Name"
                          value={searchParams.title}
                          onChange={(event) =>
                            setSearchParams({
                              ...searchParams,
                              title: event.target.value,
                            })
                          }
                        />

                        <TextField
                          className="search-item"
                          label={isInbound ? "Phone No" : "Contact Ref"}
                          value={
                            isInbound
                              ? searchParams.phoneNo
                              : searchParams.customer
                          }
                          onChange={(event) => {
                            if (isInbound) {
                              setSearchParams({
                                ...searchParams,
                                phoneNo: event.target.value,
                              });
                            } else {
                              setSearchParams({
                                ...searchParams,
                                customer: event.target.value,
                              });
                            }
                          }}
                        />

                        <Autocomplete
                          className="search-item"
                          filterSelectedOptions
                          multiple
                          options={agentData}
                          value={displayValues.agent}
                          getOptionLabel={(agent) => agent.name}
                          onChange={(event, value) => {
                            setSearchParams({
                              ...searchParams,
                              agent: value?.length
                                ? value.map((val) => val.id)
                                : "",
                            });

                            setDisplayValues({
                              ...displayValues,
                              agent: value,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Agent Name" />
                          )}
                        />
                      </>
                    )}

                    <button
                      className="search-button"
                      onClick={() => {
                        setSearchParams({
                          ...searchParams,
                          skip: 0,
                        });

                        dispatch({
                          type: SET_TABLE_PAGE,
                          payload: { tablePage: 0 },
                        });

                        fetchData();
                      }}
                    >
                      <Icon height="20" icon="mingcute:search-line" />
                      Search
                    </button>
                  </div>

                  {!isInbound && (
                    <div className="row">
                      {isTelemarketing ? (
                        <>
                          <div className="date-range">
                            <DatePicker
                              disableFuture
                              label="Start Selling Time"
                              maxDate={searchParams.endSellingTime}
                              value={searchParams.startSellingTime}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                              onChange={(newValue) =>
                                setSearchParams({
                                  ...searchParams,
                                  startSellingTime: newValue,
                                })
                              }
                            />

                            <Icon
                              color="#7E7E7E"
                              icon="mdi:arrow-expand"
                              width="24"
                            />

                            <DatePicker
                              disableFuture
                              label="End Selling Time"
                              minDate={searchParams.startSellingTime}
                              value={searchParams.endSellingTime}
                              renderInput={(params) => (
                                <TextField {...params} />
                              )}
                              onChange={(newValue) =>
                                setSearchParams({
                                  ...searchParams,
                                  endSellingTime: newValue,
                                })
                              }
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <Autocomplete
                            className="search-item"
                            filterSelectedOptions
                            multiple
                            options={masterData.master_contact}
                            value={displayValues.contact}
                            getOptionLabel={(contact) => contact.Description}
                            onChange={(event, value) => {
                              setSearchParams({
                                ...searchParams,
                                contactby: value?.length
                                  ? value.map((val) => val.ContactID)
                                  : "",
                              });

                              setDisplayValues({
                                ...displayValues,
                                contact: value,
                              });
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Data Filter" />
                            )}
                          />

                          <Autocomplete
                            className="search-item"
                            filterSelectedOptions
                            multiple
                            options={masterData.master_status}
                            value={displayValues.status}
                            getOptionLabel={(status) => status.Description}
                            onChange={(event, value) => {
                              setSearchParams({
                                ...searchParams,
                                status: value?.length
                                  ? value.map((val) => val.StatusID)
                                  : "",
                              });

                              setDisplayValues({
                                ...displayValues,
                                status: value,
                              });
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Status Call" />
                            )}
                          />

                          {/* Fillers */}
                          <p className="search-item"> </p>
                          <button className="clear-button filler" />
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className={`container-body ${isInbound ? "inbound" : ""}`}>
              <DataGrid
                autoPageSize
                className="table"
                columns={
                  isInbound
                    ? columnsInbound
                    : isTelemarketing
                      ? columnsTSS
                      : columns
                }
                disableColumnFilter
                disableColumnMenu
                disableSelectionOnClick
                headerHeight={75}
                loading={isLoading}
                page={tablePage}
                pageSize={isInbound && 50}
                paginationMode={isInbound && "server"}
                rowCount={isInbound && countData}
                rows={
                  isInbound ? listInbound : isTelemarketing ? listQA : dummy
                }
                rowsPerPageOptions={isInbound && []} // hide rows per page
                getRowHeight={() => "auto"}
                getRowId={(row) =>
                  isInbound
                    ? row.logacdcallid
                    : isTelemarketing
                      ? row.ApplicationID
                      : row.ID
                }
                onPageChange={(newPage) => {
                  if (newPage > tablePage) {
                    fetchData(searchParams.skip + 50);

                    setSearchParams((prevState) => {
                      return {
                        ...searchParams,
                        skip: prevState.skip + 50,
                      };
                    });
                  } else {
                    fetchData(searchParams.skip - 50);

                    setSearchParams((prevState) => {
                      return {
                        ...searchParams,
                        skip: prevState.skip - 50,
                      };
                    });
                  }

                  dispatch({
                    type: SET_TABLE_PAGE,
                    payload: { tablePage: newPage },
                  });
                }}
              />
            </div>
          </div>
        )}
      </div>

      {isQAFormDialogShown && (
        <NewWindow
          copyStyles
          features={{
            height: 550,
            width: width >= 1440 ? 1440 : 900,
          }}
          onUnload={() => setIsQAFormDialogShown(false)}
        >
          <QAForm
            filledComment={selectedLogItem?.comment}
            filledTotalScore={selectedLogItem?.totalscore}
            logID={selectedLogItem?.logacdcallid}
            isInbound={isInbound}
            scoreItemID={selectedLogItem?.scoreitemid}
            setIsQAFormDialogShown={setIsQAFormDialogShown}
          />
        </NewWindow>
      )}

      {selectedRecording && (
        <NewWindow
          features={{
            height: 100,
            width: 400,
          }}
          onUnload={() => setSelectedRecording(null)}
        >
          <div
            className={`controls new-window ${
              !isSeekVoiceAllowed ? "simple" : ""
            }`}
          >
            {isSeekVoiceAllowed ? (
              // Audio with controls if seek voice is allowed
              <audio
                controls
                controlsList="nodownload"
                src={`data:audio/wav;base64,${selectedRecording?.filebytes}`}
              />
            ) : (
              // Play/pause button if seek voice is not allowed
              <Button
                className="download-button"
                variant="contained"
                onClick={() => {
                  if (isRecordingPlaying) {
                    recordingRef.current.pause();
                    setIsRecordingPlaying(false);
                  } else {
                    recordingRef.current.play();
                    setIsRecordingPlaying(true);
                  }
                }}
              >
                {isRecordingPlaying ? (
                  <Icon height="24" icon="ic:round-pause" />
                ) : (
                  <Icon height="24" icon="ph:play-fill" />
                )}
              </Button>
            )}

            <a
              download={selectedRecording?.filename}
              href={`data:audio/wav;base64,${selectedRecording?.filebytes}`}
            >
              <Button variant="contained" className="download-button">
                <Download />
              </Button>
            </a>
          </div>
        </NewWindow>
      )}
    </div>
  );
}
